import React, { useState } from 'react'

import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'

import AddGroupDialog from 'components_new/organisms/dialogs/AddGroupDialog'
import GroupList from 'components_new/organisms/GroupList'

import PageLayout from 'components_new/templates/PageLayout'

import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useGroups } from 'redux/hooks/Groups'
import { useIsMobile } from 'utils/hooks'
import { useTranslation } from 'language/translator'

const Metrics = () => {
  const [addGroupDialogOpen, setAddGroupDialogOpen] = useState<boolean>(false)

  const { allGroups } = useGroups()
  const { isAdmin } = useAccountSettings()
  const isMobile = useIsMobile()

  const { t } = useTranslation()

  return (
    <>
      <PageLayout
        footer={{
          mobile: {
            showNavigation: true
          }
        }}
        topbar={{
          actions:
            isAdmin && !isMobile ? (
              <>
                <Button
                  onClick={() => setAddGroupDialogOpen(true)}
                  startIcon={<Icon name="AddOutlined" />}
                  variant="text"
                >
                  {t('global', 'create')}
                </Button>
              </>
            ) : null,
          breadcrumbs: [
            { icon: { name: 'Groups' }, title: t('global', 'groups') }
          ]
        }}
        variant="feed"
      >
        <GroupList groups={allGroups} seperateMyGroups={true} />
      </PageLayout>
      {isAdmin ? (
        <AddGroupDialog
          open={addGroupDialogOpen}
          onClose={() => setAddGroupDialogOpen(false)}
        />
      ) : null}
    </>
  )
}

export default Metrics
